(() => {
  const initializeEmptyCartSliders = root => {
    root.querySelectorAll('.cart-empty-product-slider').forEach(slider => {
      if (slider.dataset.sliderInitialized === 'true') return;
      slider.dataset.sliderInitialized = 'true';

      const track = slider.querySelector('[data-empty-cart-slider]');
      const prev = slider.querySelector('[data-empty-cart-slider-prev]');
      const next = slider.querySelector('[data-empty-cart-slider-next]');
      if (!track || !prev || !next) return;

      const updateButtons = () => {
        const maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      const scrollByCard = direction => {
        const card = track.firstElementChild;
        const amount = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };

      prev.addEventListener('click', () => scrollByCard(-1));
      next.addEventListener('click', () => scrollByCard(1));
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  };

  const renderEmptyCartProducts = async root => {
    const wrapper = root.querySelector('[data-empty-cart-products]');
    if (!wrapper || wrapper.dataset.initialized === 'true') {
      initializeEmptyCartSliders(root);
      return;
    }
    wrapper.dataset.initialized = 'true';

    const recentsWrapper = wrapper.querySelector('[data-empty-cart-recents]');
    const recentsList = wrapper.querySelector('[data-empty-cart-recents-list]');
    const fallback = wrapper.querySelector('[data-empty-cart-fallback]');
    const handles = (localStorage.getItem('recently-viewed') || '')
      .split(',')
      .map(handle => handle.trim())
      .filter(Boolean)
      .filter((handle, index, array) => array.indexOf(handle) === index)
      .slice(0, 4);

    if (handles.length && recentsWrapper && recentsList) {
      const cards = [];
      await Promise.all(handles.map(async handle => {
        try {
          const response = await fetch(`${window.Shopify.routes.root}products/${handle}?view=card`);
          if (!response.ok) return;
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          if (!doc.querySelector('card-product') && !doc.querySelector('.card-product')) return;
          cards.push(html);
        } catch (error) {}
      }));

      if (cards.length) {
        recentsList.innerHTML = '';
        cards.slice(0, 4).forEach(card => {
          const item = document.createElement('div');
          item.className = 'cart-drawer__empty-recently-viewed-item';
          item.innerHTML = card;
          recentsList.append(item);
        });

        fallback?.setAttribute('hidden', '');
        recentsWrapper.removeAttribute('hidden');
      }
    }

    initializeEmptyCartSliders(root);
  };

  const renderAll = () => document.querySelectorAll('cart-drawer, #CartDrawer-Body, cart-items, .cart').forEach(renderEmptyCartProducts);
  document.addEventListener('DOMContentLoaded', renderAll);
  document.addEventListener('shopify:section:load', renderAll);
  new MutationObserver(renderAll).observe(document.documentElement, { childList: true, subtree: true });
})();
